import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import { MdsPanelHeader } from "@/design-system/components/panel-header";
import { useAppStore } from "@/store";
import { MdsTextSize } from "@/design-system/components/text";
import { MdsTextWeight } from "@/design-system/components/text";

export const IntegrationsTextMessagePageHeader: FC = observer(() => {
  const { store } = useAppStore();
  return (
    <Wrapper>
      <MdsPanelHeader
        heading="SMS & WhatsApp Integration"
        headingTextProps={{
          size: MdsTextSize.Small,
          lineHeight: MdsTextSize.XSmall,
          weight: MdsTextWeight.Medium,
        }}
        icon={<span />}
        onBackClick={store.navigation.goBack}
      />
    </Wrapper>
  );
});

const Wrapper = styled.div(() => ({}));
